import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae3a5ef4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "model-content" }
const _hoisted_2 = {
  key: 0,
  class: "model-head"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "model-menus" }
const _hoisted_5 = ["onClick"]

import { onMounted, ref } from 'vue'
import { usePromisifyDialog } from '@shared/utils/dialog'

type TAction = {
  id: string
  text: string
  loadingText?: string
  callback: Function
}

interface IProps {
  maskClosable?: boolean
  actions: TAction[]
  title?: string
  content?: string
  type?: 'modal' | 'actionsheet'
  hideCancel?:boolean
}

interface IEmit {
  (e: 'dialog-close'): void
}


export default /*#__PURE__*/_defineComponent({
  props: {
    maskClosable: { type: Boolean },
    actions: null,
    title: null,
    content: null,
    type: null,
    hideCancel: { type: Boolean }
  },
  emits: ["dialog-close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'dialog-close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  maskClosable?: boolean
  actions: TAction[]
  title?: string
  content?: string
  type?: 'modal' | 'actionsheet'
  hideCancel?:boolean
}




const isMountedRef = ref(false)
const loadingIdRef = ref('')

const { close } = usePromisifyDialog(emit)
const noop = () => {}
const handleClose = () => {
  isMountedRef.value = false
  setTimeout(() => {
    close(null)
  }, 300)
}

const handleOnAction = async (callback: Function, loadingId = '') => {
  loadingIdRef.value = loadingId
  let isKeep = false
  try {
    if (typeof callback === 'function') {
      const ret = callback()
      if (ret instanceof Promise) {
        isKeep = await ret
      }
    }
  } catch (err) {
    console.log('err', err)
    isKeep = false
  } finally {
    loadingIdRef.value = ''
    if (!isKeep) handleClose()
  }
}


onMounted(() => {
  setTimeout(() => {
    isMountedRef.value = true
  }, 0)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass(["pop-wrapper pop-wrapper-as", { 'is-mounted': isMountedRef.value }]),
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (props.maskClosable ? handleClose() : noop()), ["self"]))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["model", props.type]),
        tabindex: "0"
      }, [
        _createElementVNode("div", _hoisted_1, [
          (props.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("h3", null, _toDisplayString(props.title), 1),
                _createElementVNode("i", {
                  class: "icomoon-close",
                  onClick: handleClose
                }),
                (props.content)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(props.content), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.actions, (action) => {
              return (_openBlock(), _createElementBlock("li", {
                key: action.id,
                onClick: ($event: any) => (handleOnAction(action.callback, action.loadingText ? action.id : ''))
              }, _toDisplayString(loadingIdRef.value === action.id ? action.loadingText : action.text), 9, _hoisted_5))
            }), 128)),
            (!props.hideCancel)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: "cancel",
                  onClick: handleClose
                }, " 取消 "))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2)
    ], 2)
  ]))
}
}

})